module.exports = __webpack_public_path__ + "img/swiper_07.6cce604b.jpg";